module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-content-full-width grid"
  }, [_c('cmp-to-top'), _vm._v(" "), _c('div', {
    staticClass: "grid--container"
  }, [_c('div', {
    staticClass: "grid--row p-content-full-width--row"
  }, [_c('div', {
    staticClass: "p-content-full-width--col grid--col"
  }, [_c('cmp-breadcrumbs', {
    attrs: {
      "tree": _vm.routeData.breadcrumbs
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "grid--row p-content-full-width--row"
  }, [_c('div', {
    staticClass: "p-content-full-width--col grid--col"
  }, [_c('cmp-main', {
    attrs: {
      "container": _vm.containers.main
    }
  })], 1)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-02c0d17e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02c0d17e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/pages/content-full-width/index.vue
// module id = 502
// module chunks = 7